/**
 * Convert milliseconds remaining into a compact countdown string.
 * ≥ 1 hour → "Xh Ym", < 1 hour → "Xm Ys".
 */
export function formatCountdown(ms: number): string {
  if (ms <= 0) return '0m 0s';
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  if (hours >= 1) return `${hours}h ${minutes}m`;
  return `${minutes}m ${seconds}s`;
}
